/**
 * The dose / medicine units the API accepts (GET /system/unit-kinds reads the database enum), so a
 * unit added there (D-21: application, tube, bottle, unit, patch, spray) shows without a web
 * release. Until it answers, or if it fails, the list known at build time is used.
 */

import { useQuery } from "@tanstack/react-query";

import { getUnitKinds } from "../api/catalogue";
import { UNIT_KINDS } from "./rxLines";

export function useUnitKinds(): string[] {
  const { data } = useQuery({ queryKey: ["unit-kinds"], queryFn: getUnitKinds, staleTime: 60 * 60_000 });
  const published = (data?.unit_kinds ?? []).filter((u): u is string => typeof u === "string" && u !== "");
  return published.length ? published : UNIT_KINDS;
}
